import BootstrapField from '../utility/BootstrapField';

export default class AuditLogFilter {
	constructor(data) {
		if (!data) {
			data = {};
		}

		Object.assign(this, {
			logDateFrom: new BootstrapField({ value: data.logDateFrom ? new Date(data.logDateFrom) : null, type: BootstrapField.Types.date }),
			logDateTo: new BootstrapField({ value: data.contributionDateTo ? new Date(data.contributionDateTo) : null, type: BootstrapField.Types.date }),

			userName: new BootstrapField({ value: data.userName || null, type: BootstrapField.Types.text }),

			notes: new BootstrapField({ value: data.notes || null, type: BootstrapField.Types.text }),

			pageIndex: null,
			pageSize: null,
			orderby: null,
			orderbyRaw: null
		});
	}
	getValue() {
		let value = {};
		for (let key in this) {
			if (this[key] instanceof BootstrapField) {
				Object.assign(value, { [key]: this[key].getValue() });
			}
			else {
				Object.assign(value, { [key]: this[key] });
			}
		}
		return value;
	}
	query() {
		let val = this.getValue();
		for (let key in val) {
			if (val[key] == null) {
				val[key] = undefined;
			}
			else if (val[key] instanceof Date) {
				val[key] = val[key].getTime();
			}
		}
		return val;
	}
}
